import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldIcon, ZapIcon, CrosshairIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-14 bg-forest text-white relative overflow-hidden" data-id="element-85">
      {/* Tactical background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-86"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-87">
        <FadeIn data-id="element-88">
          <div className="text-center mb-10" data-id="element-89">
            <ShieldIcon className="w-16 h-16 text-leaf mx-auto mb-6" data-id="element-90" />
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-91">
              El Escudo Metabólico
            </h2>
            <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-92">
              Este no es un libro de medicina, es una estrategia de guerrilla
              nutricional.
            </p>
          </div>
        </FadeIn>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 md:p-12" data-id="element-93">
          <FadeIn delay={0.1} data-id="element-94">
            <p className="text-lg md:text-xl leading-relaxed mb-8 text-center" data-id="element-95">
              A diferencia de las dietas restrictivas que generan rechazo, este
              sistema utiliza el{' '}
              <strong className="bg-white/10 px-2 py-1 rounded text-[#00000]" data-id="element-96">
                "Intercambio Táctico"
              </strong>
              : sustituimos el combustible basura por nutrición real de alta
              densidad <em data-id="element-97">sin que tu hijo note la diferencia en el sabor</em>.
            </p>
          </FadeIn>

          <div className="grid sm:grid-cols-2 gap-8 mt-12" data-id="element-98">
            <FadeIn delay={0.2} className="flex items-start space-x-4" data-id="element-99">
              <div className="bg-leaf/20 p-3 rounded-xl" data-id="element-100">
                <CrosshairIcon className="w-6 h-6 text-leaf bg-[#fffff]" data-id="element-101" />
              </div>
              <div data-id="element-102">
                <h3 className="font-bold text-lg mb-2" data-id="element-103">
                  La Comida como Farmacia
                </h3>
                <p className="text-cream/70 text-sm" data-id="element-104">
                  Aprenderás a usar ingredientes específicos como tu primera
                  línea de defensa en el hogar.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} className="flex items-start space-x-4" data-id="element-105">
              <div className="bg-leaf/20 p-3 rounded-xl" data-id="element-106">
                <ZapIcon className="w-6 h-6 text-leaf" data-id="element-107" />
              </div>
              <div data-id="element-108">
                <h3 className="font-bold text-lg mb-2" data-id="element-109">Estabilidad Total</h3>
                <p className="text-cream/70 text-sm" data-id="element-110">
                  Estabiliza la glucosa de tu hijo para que su cuerpo y su mente
                  funcionen al 100% todo el día.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}